import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdbFileUploadComponent } from 'mdb-angular-file-upload';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environments';
import { ShowInfoSwal } from 'src/app/helpers/ShowInfoSwal';
import { Menu } from 'src/app/models/interfaces.model';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';

@Component({
  selector: 'app-modal-menu',
  templateUrl: './modal-menu.component.html',
  styleUrls: ['./modal-menu.component.css']
})
export class ModalMenuComponent {
  @ViewChild('fileUpload') fileUpload!: MdbFileUploadComponent;
  menuForm: FormGroup;
  @Output() OnGuardarClicked: EventEmitter<any> = new EventEmitter();
  modalTitle: string | null = null;
  activeMenu: number = 0;
  isDynamicCheck: number = 1;
  checkSubMenu: number = 0;
  edit: number = 0;
  id: number = -1;
  archivoMenu: File | null = null;
  infoMenus: any[] = [];
  appsInDataBase: any;
  infoApps: any;
  AllCompaniesAndApps: any;
  CompanySelected: any = [];
  AllChildrenMenus: any = [];
  loading: boolean = false;
  routes_config_component_name: string = ''; 
  routes_config_module_name: string = '';
  routes_config_module_path: string = '';
  routes_config_path: string = '';
  path: string = '';
  name: string = '';
  
  constructor(
    private fb: FormBuilder,
    public modalRefMenu: MdbModalRef<ModalMenuComponent>,
    private crudService: GenericCrudService<Menu>) {
    this.menuForm = this.fb.group({
      menuName: ['', [Validators.required, Validators.minLength(5)]],
      pathName: ['', [Validators.required, Validators.minLength(15)]],
      routesConfigPath: ['', [Validators.required, Validators.minLength(5)]],
      routesConfigModulePath: ['', [Validators.required, Validators.minLength(15)]],
      routesConfigModuleName: ['', [Validators.required, Validators.minLength(5)]],
      routesConfigComponentName: ['', [Validators.required, Validators.minLength(5)]],
      selectedCompanies: [null, this.validateSelectedCompanies],
      selectedApps: [null, this.validateSelectedApps],
      // selectedSubMenu: [null, this.validateSelectedApps],
      activeMenu: [false],
      isDynamicCheck: [false],
      checkSubMenu: [0],
    });
  }

  loadingFull = true;

  ngOnInit() {
    console.log("this.activeMenu: ", this.activeMenu);
    this.menuForm.patchValue({
      id: this.id,
      isDynamicCheck: this.isDynamicCheck,
      checkSubMenu: this.checkSubMenu,
      archivoMenu: this.archivoMenu,
      routesConfigComponentName: this.routes_config_component_name,
      routesConfigModuleName: this.routes_config_module_name,
      routesConfigModulePath: this.routes_config_module_path,
      routesConfigPath: this.routes_config_path,
      pathName: this.path,
      menuName: this.name,
      activeMenu: this.activeMenu,
    });
    // this.menuForm.addControl('selectedApps', new FormControl());

    if(this.edit == 1){
      
      // this.preselectApps();
    }
    

  }

  InsertOrUpdate(): void {
    const body = new FormData();
    body.append('action', this.edit == 0 ? "INSERT" : "UPDATE");
    body.append('table_name', "MENU");
    body.append('nombre', this.menuForm.value.menuName);
    body.append('app', this.menuForm.value.selectedApps);
    body.append('company', this.menuForm.value.selectedCompanies);
    body.append('path', this.menuForm.value.pathName);
    body.append('routes_config_path', this.menuForm.value.routesConfigPath);
    body.append('routes_config_module_path', this.menuForm.value.routesConfigModulePath);
    body.append('routes_config_module_name', this.menuForm.value.routesConfigModuleName);
    body.append('routes_config_component_name', this.menuForm.value.routesConfigComponentName);

    this.menuForm.value.selectedSubMenu != undefined ? body.append('parent', this.menuForm.value.selectedSubMenu) : null;
    this.activeMenu !== null ? body.append('active', this.menuForm.value.activeMenu ? '1' : '0' ) : null;
    this.archivoMenu !== null ? body.append('icon', this.archivoMenu) : null;
    this.edit !== 0 ? body.append('id', this.id.toString()) : null;

    this.loading = true;

    this.crudService.crud(body, environment.AppMenus).pipe(
      catchError(error => {
        console.error(error);
        ShowInfoSwal(0, 'Error', error.message);
        this.loading = false;
        return throwError(error); // se puede devolver el error original o lanzar un nuevo error personalizado
      })
    ).subscribe((data: any) => {

      ShowInfoSwal(data.status, data.msg, '');
      this.OnGuardarClicked.emit(true);
      this.modalRefMenu.close();
      this.loading = false;
    });
  }

  onCompanySelectedTabMenu(event: any): void {
    try {
      let companyId = event;
      this.CompanySelected = (this.AllCompaniesAndApps.filter((company: any) => company.ID == companyId))[0];
    } catch (error) {
      console.error('Error: ', error);
      throw error;
    } finally {
      this.loadingFull = false;
    }
  }

  validateSelectedCompanies(control: FormControl) {
    const selectedOptions = control.value;
    return selectedOptions && selectedOptions.length > 0 ? null : { required: true };
  }
  
  validateSelectedApps(control: FormControl) {
    const selectedOptions = control.value;
    return selectedOptions && selectedOptions.length > 0 ? null : { required: true };
  }

  onActiveMenuCheckboxChange(event: any) {
    const isChecked = event.target.checked;
    this.activeMenu = isChecked ? 1 : 0;
  }

  onCheckSubMenuChange(event: any) {
    this.checkSubMenu = this.checkSubMenu == 1 ? 0 : 1;
  }

  onFileMenuRemoved(): void {
    this.archivoMenu = null;
  }

  onFileMenuAdded(files: File[]): void {
    this.archivoMenu = files[0];
  }

  loadData(data: any): void {
    this.AllCompaniesAndApps = data.map((company: any) => ({
      value: company.ID,
      NAME: company.NAME,
      apps: company.APPS.map((app: any) => ({
        value: app.ID_APP,
        label: app.NAME_APP
      }))
    }));
  }
}
